<script lang="ts" setup>
  import { computed } from 'vue';
  import type { RoundResultsView } from '../../../../shared/api/round.ts';
  import SongCardHorizontal from '../song/SongCardHorizontal.vue';
  import { guessVerdictByScoreType } from './guessVerdict.ts';
  import RoundResultsLayout from './RoundResultsLayout.vue';

  const props = defineProps<{ data: RoundResultsView; secondsLeft: string; isHost: boolean }>();

  const guessVerdict = computed(() => {
    const scoreType = props.data.round.songSubmissionScore?.scoreType;
    return scoreType && guessVerdictByScoreType[scoreType];
  });
</script>

<template>
  <RoundResultsLayout :data="data" :is-host="isHost" :seconds-left="secondsLeft">
    <SongCardHorizontal
      v-if="data.round.chooserSongSubmissionScore.songSubmission"
      :song="data.round.chooserSongSubmissionScore.songSubmission.song"
      label="Correct song"
    />

    <SongCardHorizontal
      :verdict="guessVerdict"
      :song="data.round.songSubmissionScore?.songSubmission?.song ?? null"
      label="Your guess"
      placeholder="You didn't submit a guess in time! 😭"
    />
  </RoundResultsLayout>
</template>
